module.exports = __webpack_public_path__ + "img/242.9398542e.png";